/** True when a claim-detail tile should render (hide blank / "No Data"). */
export function hasClaimDetailValue(value) {
  if (value == null) return false;
  const normalized = String(value).trim();
  if (normalized === '' || normalized.toLowerCase() === 'no data') return false;
  return true;
}
